<template>
	<div class="flex-space-between--center exact-match-switch">
		<h3 class="reg">Exact match only</h3>
		<v-switch class="dark small" v-model="localValue" inset dense color="white" />
	</div>
</template>
<script>
import { useIsMarketplaceExactMatch } from '@/store/modules/marketplace/getters';
import { setIsMarketplaceExactMatch } from '@/store/modules/marketplace/actions';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
export default {
	name: 'MarketplaceExactMatch',
	computed: {
		...mapGettersShorthand({ useIsMarketplaceExactMatch }),
		localValue: {
			get() {
				return this.useIsMarketplaceExactMatch;
			},
			set(value) {
				this.setIsMarketplaceExactMatch({ isMarketplaceExactMatch: value });
			},
		},
	},
	methods: {
		...mapActionsShorthand({ setIsMarketplaceExactMatch }),
	},
	data() {
		return {};
	},
	watch: {},
};
</script>
<style lang="scss" scoped>
.exact-match-switch {
	::v-deep {
		.dark .v-input--switch__track {
			background: #707070 !important;
		}
		.dark.v-input--is-label-active .v-input--switch__track {
			background: var(--bold-border-color) !important;
		}
		.small {
			transform: scale(0.75);
		}
		.v-input--selection-controls {
			padding-top: 0px;
		}
		.v-input--switch__track {
			background: #ced0da !important;
			opacity: 1 !important;
			transition: all 0.15s;
		}
		.v-input--is-label-active .v-input--switch__track {
			opacity: 1 !important;
			background: var(--bold-border-color) !important;
		}
	}
}
</style>
